import React from "react";

// Returns a React SVG component so that we may change the fill color and/or icon size of the SVG to whatever we want dynamically across hundreds of different websites and hundreds of different colors.
// This react component is the box SVG icon, typically used for the Order CTA.

const CarService = ({ fill, svgIconSize }) => {
	return (
        <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            style={{
                width: svgIconSize || "26px",
                height: svgIconSize || "26px",
                fill: fill,
                pointerEvents: "none",
            }}
            viewBox="0 0 512 512"
            enableBackground="new 0 0 512 512"
            xmlSpace="preserve"
        >
            <g>
                <g id="Page-1_12_">
                    <g id="_x30_13---Car-Service">
                        <path
                            id="Shape_35_"
                            d="M348.578,324.266H163.405c-7.725-0.008-14.625,4.829-17.254,12.093
				c-2.629,7.264-0.421,15.396,5.52,20.334l27.657,23.04c3.296,2.755,7.455,4.265,11.751,4.266h129.826
				c4.293-0.001,8.449-1.512,11.742-4.266l27.665-23.04c5.941-4.938,8.149-13.07,5.52-20.334
				C363.203,329.095,356.303,324.259,348.578,324.266z M349.431,343.586l-27.665,23.04c-0.24,0.196-0.543,0.298-0.853,0.29H191.095
				c-0.312,0.009-0.616-0.097-0.853-0.299l-27.665-23.04c-0.457-0.315-0.62-0.914-0.384-1.417c0.133-0.541,0.64-0.903,1.194-0.853
				H348.56c0.554-0.05,1.062,0.312,1.194,0.853c0.244,0.501,0.088,1.104-0.367,1.425L349.431,343.586L349.431,343.586z"
                        />
                        <path
                            id="Shape_34_"
                            d="M409.847,328.534l-27.751,23.04c-5.962,4.928-8.184,13.072-5.552,20.345
				c2.632,7.274,9.55,12.109,17.285,12.081h66.97c9.426,0,17.067-7.641,17.067-17.067v-25.6c0-9.426-7.641-17.067-17.067-17.067
				h-39.211C417.298,324.279,413.146,325.787,409.847,328.534z M460.8,341.333v25.6h-66.97c-0.558,0.055-1.07-0.309-1.204-0.853
				c-0.234-0.49-0.07-1.077,0.384-1.374l27.759-23.091c0.237-0.203,0.542-0.309,0.853-0.299L460.8,341.333z"
                        />
                        <path
                            id="Shape_33_"
                            d="M102.153,328.534c-3.285-2.74-7.422-4.248-11.699-4.266H51.2
				c-9.426,0-17.067,7.641-17.067,17.067v25.6c0,9.426,7.641,17.067,17.067,17.067h66.952c7.732,0.021,14.645-4.813,17.277-12.083
				c2.632-7.27,0.417-15.41-5.535-20.343L102.153,328.534z M119.373,366.08c-0.134,0.544-0.646,0.908-1.204,0.853H51.2v-25.6h39.254
				c0.312-0.011,0.616,0.096,0.853,0.299l27.768,23.091C119.486,365.046,119.611,365.614,119.373,366.08L119.373,366.08z"
                        />
                        <g>
                            <path
                                id="Path_56_"
                                fillRule="evenodd"
                                clipRule="evenodd"

                                d="M110.933,409.6H51.2
					c-4.712,0-8.533,3.821-8.533,8.533s3.821,8.533,8.533,8.533h59.734c4.712,0,8.533-3.821,8.533-8.533
					S115.646,409.6,110.933,409.6z"
                            />
                            <path
                                id="Path_55_"
                                fillRule="evenodd"
                                clipRule="evenodd"

                                d="M460.8,409.6h-59.734
					c-4.712,0-8.533,3.821-8.533,8.533s3.821,8.533,8.533,8.533H460.8c4.712,0,8.533-3.821,8.533-8.533S465.513,409.6,460.8,409.6z"
                            />
                            <path
                                id="Path_54_"
                                fillRule="evenodd"
                                clipRule="evenodd"

                                d="M332.8,409.6H179.2
					c-4.712,0-8.533,3.821-8.533,8.533s3.821,8.533,8.533,8.533h153.6c4.712,0,8.533-3.821,8.533-8.533S337.513,409.6,332.8,409.6z"
                            />
                        </g>
                        <path
                            id="Shape_32_"
                            d="M512,247.467c0-14.138-11.462-25.6-25.6-25.6h-17.067
				c-7.439,0.028-14.494,3.307-19.311,8.977l-16.017-47.991c-3.951-11.889-12.937-21.435-24.568-26.095
				c0-1.067,0.162-2.09,0.162-3.157C409.6,68.769,340.831,0,256,0S102.4,68.769,102.4,153.6c0,1.067,0.137,2.09,0.162,3.157
				c-11.621,4.651-20.605,14.184-24.559,26.061l-16.025,48.026c-4.817-5.67-11.871-8.95-19.311-8.977H25.6
				c-14.138,0-25.6,11.462-25.6,25.6s11.462,25.6,25.6,25.6h13.534L7.56,304.64c-4.853,4.802-7.576,11.349-7.56,18.175V435.2
				c0.045,10.81,6.875,20.426,17.067,24.03v27.17c0,14.138,11.462,25.6,25.6,25.6H102.4c14.138,0,25.6-11.462,25.6-25.6v-25.6h256
				v25.6c0,14.138,11.462,25.6,25.6,25.6h59.734c14.138,0,25.6-11.462,25.6-25.6v-27.17c10.192-3.603,17.022-13.22,17.067-24.03
				V322.816c0.015-6.814-2.698-13.35-7.535-18.15l-31.573-31.573H486.4c6.794,0,13.309-2.701,18.111-7.507
				C509.312,260.778,512.007,254.26,512,247.467L512,247.467z M417.8,188.22L440.422,256h-70.264
				c20.31-22.551,33.446-50.639,37.734-80.682C412.523,178.413,416.005,182.947,417.8,188.22z M256,17.067
				c75.405,0,136.533,61.128,136.533,136.533S331.405,290.133,256,290.133S119.466,229.006,119.466,153.6
				C119.556,78.232,180.632,17.156,256,17.067L256,17.067z M94.208,188.177c1.799-5.257,5.277-9.776,9.899-12.86
				c4.289,30.044,17.425,58.131,37.734,80.682H71.577L94.208,188.177z M25.6,256c-4.712,0-8.533-3.821-8.533-8.533
				s3.821-8.533,8.533-8.533h17.067c4.712,0,8.533,3.821,8.533,8.533V256H25.6z M110.933,486.4c0,4.712-3.821,8.533-8.533,8.533
				H42.667c-4.712,0-8.533-3.821-8.533-8.533v-25.6h76.8V486.4z M477.866,486.4c0,4.712-3.821,8.533-8.533,8.533H409.6
				c-4.712,0-8.533-3.821-8.533-8.533v-25.6h76.8L477.866,486.4z M492.373,316.732c1.635,1.602,2.557,3.794,2.56,6.084V435.2
				c0,4.712-3.821,8.533-8.533,8.533H25.6c-4.712,0-8.533-3.821-8.533-8.533V322.816c0.003-2.289,0.925-4.482,2.56-6.084
				l43.639-43.665h96.426c56.158,45.511,136.507,45.511,192.665,0h96.426L492.373,316.732z M460.8,256v-8.533
				c0-4.712,3.821-8.533,8.533-8.533H486.4c4.712,0,8.533,3.821,8.533,8.533S491.113,256,486.4,256H460.8z"
                        />
                        <path
                            id="Shape_31_"
                            d="M180.053,149.197c4.526,0.008,8.869-1.789,12.066-4.992l4.48-4.48l18.569,18.569
				l-4.267,4.267c-24.248-2.634-46.056,14.844-48.768,39.083c-0.252,5.426,2.42,10.571,7.004,13.485
				c4.584,2.914,10.377,3.151,15.183,0.621c5.572-2.97,7.68-0.853,9.029,0.589c1.348,1.442,3.481,3.413,0.564,8.84
				c-2.54,4.665-2.438,10.32,0.266,14.891c2.705,4.571,7.615,7.381,12.925,7.398h0.512c7.227-0.431,14.182-2.908,20.053-7.142
				c13.496-9.291,20.861-25.195,19.217-41.498l4.42-4.429l48.068,48.068c6.684,6.679,17.516,6.679,24.201,0l12.023-12.066
				c6.64-6.661,6.64-17.437,0-24.098l-48.068-48.059l13.492-13.5c12.95,1.634,25.926-2.83,35.132-12.083
				c7.654-7.031,12.42-16.658,13.371-27.008v-0.06c0.261-5.429-2.41-10.581-6.995-13.499c-4.587-2.918-10.384-3.152-15.191-0.616
				c-5.581,2.978-7.739,0.794-9.071-0.546s-3.507-3.516-0.453-9.002c2.509-4.789,2.284-10.55-0.589-15.129
				c-2.737-4.617-7.807-7.337-13.167-7.066c-7.23,0.433-14.189,2.913-20.062,7.151c-13.564,9.34-20.918,25.362-19.157,41.736
				l-13.449,13.457l-18.569-18.569l7.577-7.577c4.345-4.348,6.017-10.696,4.377-16.62c-1.641-5.924-6.341-10.508-12.304-12
				l-28.97-7.245c-5.818-1.439-11.964,0.263-16.214,4.488l-37.402,37.41c-3.202,3.201-5.001,7.543-5.001,12.071
				s1.799,8.87,5.001,12.071l18.107,18.107C171.191,147.414,175.531,149.208,180.053,149.197L180.053,149.197z M323.499,218.317
				L311.467,230.4l-48.086-48.043l12.075-12.075L323.499,218.317z M280.047,117.564c2.106-2.104,2.963-5.153,2.262-8.047
				c-2.313-10.96,2.186-22.237,11.409-28.595c2.241-1.602,4.74-2.806,7.39-3.558c-3.61,8.798-1.576,18.904,5.156,25.621
				c6.732,6.717,16.842,8.729,25.632,5.1c-1.522,4.77-4.232,9.076-7.876,12.51c-6.163,6.301-15.225,8.824-23.756,6.613
				c-2.915-0.74-6.005,0.109-8.132,2.236l-60.416,60.416c-2.085,2.085-2.947,5.098-2.279,7.97
				c2.201,10.917-2.313,22.097-11.478,28.424c-2.25,1.602-4.759,2.805-7.415,3.559c3.882-8.738,1.83-18.974-5.12-25.54
				c-4.186-4.515-10.057-7.092-16.214-7.117c-3.254,0.028-6.474,0.671-9.489,1.895c1.525-4.771,4.238-9.076,7.885-12.51
				c6.247-6.343,15.431-8.823,24.021-6.485c2.927,0.758,6.037-0.089,8.175-2.227L280.047,117.564z M239.326,134.144l-12.083,12.083
				l-18.569-18.569l12.083-12.083L239.326,134.144z M199.364,76.621l29.013,7.211l-48.324,48.307l-18.107-18.099L199.364,76.621z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default CarService;
